export type LayoutState = {
	collapsed: boolean;
	toggleCollapse: () => void;
};

const initialLayoutState: Pick<LayoutState, 'collapsed'> = {
	collapsed: false,
};

const createLayoutSlice = <T extends LayoutState>(
	set: (partial: Partial<T> | ((state: T) => Partial<T>)) => void,
): LayoutState => ({
	...initialLayoutState,

	toggleCollapse: () =>
		set(
			(state) =>
				({
					collapsed: !state.collapsed,
				}) as Partial<T>,
		),
});

export { createLayoutSlice };
